<div class="ft-parent-layout mat-elevation-z1" [class.ft-content-margin]="true" fxFlex fxLayout="column">
  <div fxLayout="column" fxFlex class="ft-content no-padding">
    <router-outlet></router-outlet>
  </div>
</div>
